module.exports = __webpack_public_path__ + "static/media/c-more-hits.5bc6f993.png";